<template>
  <v-card
    :subtitle="jobTitle"
    :title="currentUser?.name"
    rounded="xl"
    min-width="300"
    class="text-center"
  >
    <v-list>
      <v-sheet class="d-flex justify-center">
        <v-avatar
          color="accent"
          size="120"
        >
          <!-- <v-fab
            class="test"
            size="x-small"
            slim
            icon="mdi-pencil"
            location="bottom right"
            absolute
            color="vicyellow"
          ></v-fab> -->
          <!-- <v-icon class="px-3 py-3">
                mdi-shield-account
            </v-icon> -->
          <v-img
            v-if="currentUser?.graphPhoto"
            :src="currentUser?.graphPhoto"
          />
          <span v-else>{{ currentUser?.name }}</span>
        </v-avatar>
      </v-sheet>

      <v-card-subtitle class="mt-2">
        v{{ appVersion }} (build {{ buildNumber }})
      </v-card-subtitle>
      <v-btn
        flat
        class="mt-4 mb-2"
        color="secondary"
        variant="outlined"
        rounded="xl"
        :text="t('appBarAvatarCard.editProfile')"
        @click="editProfile"
      />
      <v-btn
        flat
        class="ml-2 mt-4 mb-2"
        color="warning"
        variant="outlined"
        rounded="xl"
        :text="t('appBarAvatarCard.logOut')"
        @click="handleLogout"
      />
    </v-list>
  </v-card>
</template>
<script setup lang="ts">
import { ref, watch, onMounted } from "vue";
// import { useUserStore } from "@/models/User";
import { useRepo } from "pinia-orm";
// import type { AccountInfo } from '@azure/msal-browser'
import Account from "@/models/Account";
import User from "@/models/User";
import { useI18n } from "vue-i18n"
import {
  login,
  logout,
  getCurrentAccount,
  getAccessToken,
  fetchProfilePhoto,
} from "@/plugins/msal";
import axios from "axios";
import type { UserInfo } from "../types";

const { t, locale } = useI18n();
const accountRepo = useRepo(Account);
const userRepo = useRepo(User);
const currentUser = computed<Account | null>(
  () => accountRepo.first() as Account | null
);

// Compute the job title, returning an empty string if undefined
const jobTitle = computed<string>(() => {
  const userId = currentUser?.value?.localAccountId ?? "";
  const user = userRepo.find(userId);
  return user?.jobTitle || ""; // Return an empty string if jobTitle is undefined
});

// Get app version and build number from environment variables
const appVersion = import.meta.env.VITE_APP_VERSION || "0.0.0";
const buildNumber = import.meta.env.VITE_BUILDNUMBER || "0";

const handleLogout = () => {
  logout();
  accountRepo.flush();
};
const userAlias = (user: Partial<UserInfo>) => {
  return user?.username?.split("@")[0] || "";
};

const editProfile = () => {
  if (currentUser?.value?.localAccountId) {
    const newWindow = window.open(
      `https://vicoma-my.sharepoint.com/person.aspx`,
      "_blank"
    );
    if (newWindow) {
      newWindow.focus();
    }
  }
};
</script>
<style scoped></style>
